
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from "next-translate/useTranslation";
import { useIsMobile, withDeviceType } from "../lib/media";
import { Text, Box } from "rebass/styled-components";
import Layout from "../components/Layout";
import HeroLanding from "../components/landings/HeroLanding";
import Headline from "../components/common/Headline";
import TextWithImg from "../components/TextWithImg";
import { useContext } from "react";
import { LocaleContext } from "../components/locale";
import Accordion from "../components/common/Accordion";
import { pushRoute } from "../lib/routing";
import { benefitsStyles } from "../lib/styles/landingStyles";
const Benefits = () => {
    const { t } = useTranslation("ourservices");
    const benefitIcons = ["vet", "cancellation", "vetted", "secure", "support"];
    const listBenefits = [...Array(5)].map((_, i) => {
        return {
            icon: benefitIcons[i],
            title: t(`benefitTitle${i + 1}`),
            description: t(`benefitDesc${i + 1}`)
        };
    });
    const additionalInfo = {
        iconColor: "samoyedWhite",
        textColor: "samoyedWhite",
        expandIcon: "plus",
        retractIcon: "minus",
        expandIconColor: "samoyedWhite"
    };
    return (<Box sx={benefitsStyles.ourservices.box}>
      <Text as="h2" sx={benefitsStyles.ourservices.title}>
        {t("ourservices:gudogBenefits")}
      </Text>
      <Accordion items={listBenefits} additionalInfo={additionalInfo}/>
    </Box>);
};
interface Props {
    deviceType?: string;
}
function OurServices(props: Props) {
    const { deviceType } = props;
    const { t } = useTranslation("ourservices");
    const { country } = useContext(LocaleContext);
    const isMobileViewport = useIsMobile(deviceType);
    // Images
    const imgCover = "/images/landings/services_header_desktop.webp";
    const imgBoarding = "/images/landings/advicefor_before_booking.webp";
    const imgDayCare = "/images/landings/advicefor_after_booking.webp";
    const imgWalking = "/images/landings/advicefor_meet_and_greet.webp";
    const imgDropInVisits = "/images/landings/benefits_relax.webp";
    const imgHouseSitting = isMobileViewport
        ? "/images/landings/ourservices_house_sitting_vertical.webp"
        : "/images/landings/ourservices_house_sitting.webp";
    // Action
    const onButtonClick = () => {
        pushRoute({ pathname: "/search" });
    };
    return (<Layout withTransparentHeader title={t("ourservices:pageTitle")} displayFooterAreas withHrefLang>
      <HeroLanding isMobileViewport={isMobileViewport} imgsrc={imgCover} imgAlt={t("ourservices:pageTitle")} title={t("title")} button={{ text: t("common:start"), onSubmit: onButtonClick }} height={["400px", "400px", "480px"]}/>

      <Headline variant="ourservices" title={t("ourservices:heading")}/>

      <TextWithImg title={t("ourservices:boardingTitle")} imgsrc={imgBoarding} imgAlt={t("ourservices:boardingTitle")} imgRight>
        <Text as="p" variant={"textWithImg.text"}>
          {t("ourservices:boardingDesc")}
        </Text>
      </TextWithImg>

      <TextWithImg title={t("ourservices:dayCareTitle")} imgsrc={imgDayCare} imgAlt={t("ourservices:dayCareTitle")} imgLeft bgColor="samoyedWhite" color="labradorBlack" showImgMobile={false}>
        <Text as="p" variant={"textWithImg.text"}>
          {t("ourservices:dayCareDesc")}
        </Text>
      </TextWithImg>

      <TextWithImg title={t("ourservices:walkingTitle")} imgsrc={imgWalking} imgAlt={t("ourservices:walkingTitle")} imgRight={!isMobileViewport}>
        <Text as="p" variant={"textWithImg.text"}>
          {t("ourservices:walkingDesc")}
        </Text>
      </TextWithImg>

      <TextWithImg title={t("ourservices:dropInVisitsTitle")} imgsrc={imgDropInVisits} imgAlt={t("ourservices:dropInVisitsTitle")} imgLeft={!isMobileViewport}>
        <Text as="p" variant={"textWithImg.text"}>
          {t("ourservices:dropInVisitsDesc")}
        </Text>
      </TextWithImg>

      {["dk", "no", "se"].includes(country) && (<TextWithImg title={t("ourservices:houseSittingTitle")} imgsrc={imgHouseSitting} imgAlt={t("ourservices:houseSittingTitle")} imgRight bgColor="samoyedWhite" color="labradorBlack">
          <Text as="p" variant={"textWithImg.text"}>
            {t("ourservices:houseSittingDesc")}
          </Text>
        </TextWithImg>)}

      <Benefits />
    </Layout>);
}
const getServerSideProps = withDeviceType()();
export default OurServices;

    async function __Next_Translate__getServerSideProps__1987f3f228b__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ourservices',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1987f3f228b__ as getServerSideProps }
  